import React, { useCallback, useEffect } from 'react'
import { Modal, Form, Input, message } from 'antd'
import { COMPONENT_NAME_LIMIT } from '../../../../../constants/input-limits'

const RenameComponentModal = ({ 
    open, 
    component, 
    existingComponents = [],
    onRename, 
    onCancel 
}) => {
    const [form] = Form.useForm()

    useEffect(() => {
        if (open && component) {
            form.setFieldsValue({ componentName: component.name })
        }
    }, [open, component, form])

    const handleFinish = useCallback(async (values) => {
        const newName = values.componentName.trim()
        const isDuplicate = existingComponents.some(
            c => c.id !== component.id && c.name.toLowerCase() === newName.toLowerCase()
        )
        
        if (isDuplicate) {
            message.error('A component with this name already exists. Please choose a different name.')
            return
        }

        try {
            await onRename(component.id, newName)
            form.resetFields()
            message.success('Component renamed successfully!')
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error renaming component:', error)
            message.error('Failed to rename component. Please try again.')
        }
    }, [component, existingComponents, onRename, form])

    const handleCancel = useCallback(() => {
        form.resetFields()
        onCancel()
    }, [form, onCancel])

    return (
        <Modal
            title="Rename Component"
            open={open}
            onCancel={handleCancel}
            okText="Save"
            cancelText="Cancel"
            onOk={() => form.submit()}
        >
            <Form
                form={form}
                onFinish={handleFinish}
                layout="vertical"
                autoComplete="off"
                requiredMark={false}
            >
                <Form.Item
                    name="componentName"
                    label="Name"
                    rules={[
                        { required: true, message: 'Please enter a component name' },
                        { max: COMPONENT_NAME_LIMIT, message: `Component name cannot exceed ${COMPONENT_NAME_LIMIT} characters` }
                    ]}
                >
                    <Input
                        placeholder="Enter component name"
                        maxLength={COMPONENT_NAME_LIMIT}
                        showCount
                        autoFocus
                        onPressEnter={() => form.submit()}
                    />
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default RenameComponentModal

